import _ from "lodash";
export default (state = [], action: any) => {
	switch (action.type) {
		case "GET_COMMENT_SUCCESS":
			return _.unionBy([action.resource], state, "id");
		case "GET_COMMENTS_SUCCESS":
			return _.unionBy(action.resource as tcpinpoint.Comment[], state, "id");
		case "CLEAR_SESSION":
			return [];
		default:
			return state;
	}
};
